import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";


export const useSnackBar = (props: {
    queryErrorMessage?: string
    mutationErrorMessage?: string
    mutationSuccessMessage?: string
    loadingMessage?: string
}) => {
    const [loading, setLoading] = useState(false)  

    const [queryError, setQueryError] = useState(false)
    
    const [mutationError, setMutationError] = useState(false)
    const [mutationSuccess, setMutationSuccess] = useState(false)


    const loadStart = useCallback(() => {
      setQueryError(false)
      setMutationSuccess(false)
      setMutationError(false)
      setLoading(true)
    }, [])

    const onQueryError = useCallback(() => {
        setLoading(false)
        setQueryError(true)
        setMutationSuccess(false)
        setMutationError(false)
    }, [])


    const onQuerySuccess = useCallback(() => {
      setLoading(false)
      setQueryError(false)
      setMutationSuccess(false)
      setMutationError(false)
  }, [])

    const onMutationError = useCallback(() => {
        setLoading(false)
        setQueryError(false)
        setMutationSuccess(false)
        setMutationError(true)
    }, [])

    const onMutationSuccess = useCallback(() => {
      setLoading(false)
      setQueryError(false)
      setMutationSuccess(true)
      setMutationError(false)
  }, [])

    const component = useMemo(() => {
        const queryErrorBar = (
          <Snackbar open={true} onClose={() => { setQueryError(false) }}>
            <Alert severity="error" sx={{ margin: "auto" }}>
              {props.queryErrorMessage || "読み込みに失敗しました。もう一度お試しください。"}
            </Alert>
          </Snackbar>
        )

        const mutationErrorBar = (
          <Snackbar open={true} onClose={() => { setMutationError(false) }}>
            <Alert severity="error" sx={{ margin: "auto" }}>
              {props.queryErrorMessage || "送信に失敗しました。もう一度お試しください。"}
            </Alert>
          </Snackbar>
        )

        const mutationSuccessBar = (
          <Snackbar open={true} onClose={() => { setMutationSuccess(false) }}>
            <Alert severity="success" sx={{ margin: "auto" }}>
              {props.mutationSuccessMessage || "正常に送信されました。"}
            </Alert>
          </Snackbar>
        )

        const loadingDisplay = (
          <Backdrop sx={{zIndex: 1005}} open>
            <div>
              <CircularProgress />
            </div>
            <div
              style={{
                color: "white",
                fontSize: "16px",
              }}
            >
              {
                props.loadingMessage ?? "読み込みに時間がかかる場合があります"
              }
            </div>
          </Backdrop>
        );
        
        return (
          loading ? loadingDisplay : queryError ? queryErrorBar : mutationError ? mutationErrorBar : mutationSuccess ? mutationSuccessBar : <></>
        )
        
    }, [loading, mutationError, mutationSuccess, props.loadingMessage, props.mutationSuccessMessage, props.queryErrorMessage, queryError])


    return {
      loadStart,
      onQueryError,
      onQuerySuccess,
      onMutationError,
      onMutationSuccess,
      component,
    }
}


